import React from 'react'
import PropTypes from 'prop-types'
import './RootLayout.scss'
import {renderRoutes} from 'react-router-config'

export const RootLayout = ({route}) => {
  return (
    <div className={'root-layout'}>
      {renderRoutes(route.routes)}
    </div>
  )
};

RootLayout.propTypes = {
  children: PropTypes.node,
};

export default RootLayout



// WEBPACK FOOTER //
// ./src/layouts/RootLayout/RootLayout.js